import React, {ReactElement} from 'react';
import {randomItem} from 'shared/utils/randomItem';
import {Text} from 'components/Text';
import {tips} from './tips';

const randomTip = randomItem(tips);

export const RandomTip = (): ReactElement => <Text data-test='tip'>{randomTip}</Text>;
